import React, { useState, useEffect } from "react";
import {
  FaAngleDown,
  FaAngleLeft,
  FaPhone,
  FaVideo,
  FaPaperPlane,
  FaFire,
  FaSmile,
} from "react-icons/fa";
import UserContext from "../../UserContext";
import { getMessages, sendMessage } from "../../utils/functions";
import { url } from "../../utils/url";
import MessagesComponent from "./MessagesComponent";
import Picker, { SKIN_TONE_MEDIUM_DARK } from "emoji-picker-react";

import UserProfile from "../../images/avatar-defaul-girls.jpg";
export default function DisplayChatComponent({
  selected = {},
  load,
  toggleLoad,
  goBack,
  preloadedMessages = [],
}) {
  const { user, mode } = React.useContext(UserContext);
  const [message, setmessage] = React.useState("");
  const [messages, setmessages] = React.useState(selected.messages || []);
  const [loadingMessages, setloadingMessages] = React.useState(true);
  const [dark, setDark] = useState(false);
  const [isEmojiPickerShown, setisEmojiPickerShown] = React.useState(false);
  const [tempMessage, settempMessage] = React.useState(null);

  const toggleEmojiPicker = () => {
    setisEmojiPickerShown(!isEmojiPickerShown);
  };

  const handlemessage = (e) => {
    setmessage(e.target.value);
  };

  const sendmessage = async (e) => {
    e.preventDefault();
    setisEmojiPickerShown(false);
    if (!message) {
      alert("Enter message");
      return;
    }
    let newMessage = {
      createdAt: new Date().toISOString(),
      from: user.info,
      message,
      to: selected,
      status: "unread",
      _id: "123456789",
    };
    setmessage("");
    settempMessage(newMessage);
    let response = await sendMessage(
      { message: newMessage.message },
      selected._id,
      user.token
    );
    if (!response || !response?.data?.success) {
      settempMessage(null);
      setmessage(newMessage.message);
      return;
    }
    toggleLoad();
  };

  const inputkeyup = (e) => {
    if (e.key === "Enter") {
      sendmessage(e);
    }
  };

  const onEmojiClick = (_event, emojiObject) => {
    setmessage(`${message}${emojiObject.emoji}`);
  };

  const changeMessages = (newMessages = []) => {
    /**
     * question: How to get current state value of a variable from an asynchronous function in useEffect
     * value of 'selected' variable needs to be of current state value
     *
     * @proposedSolution using sessionStorage
     */

    let sel = sessionStorage.getItem("selected")
      ? JSON.parse(sessionStorage.getItem("selected"))
      : {};
    let t = newMessages[0];
    let messageAssociatedToSelected =
      (t.from?._id === sel._id && t.to._id === user.info?._id) ||
      (t.to?._id === sel._id && t.from._id === user.info?._id);
    // console.log({
    //   associated: messageAssociatedToSelected,
    //   From: t.from._id,
    //   to: t.to?._id,
    //   selected: sel._id,
    // });
    if (messageAssociatedToSelected) {
      setmessages(newMessages);
    }
  };

  React.useEffect(() => {
    const loadMessages = async () => {
      setloadingMessages(true);
      let tempMessages = await getMessages(selected._id, user.token);
      if (tempMessages.length > 0) {
        changeMessages(tempMessages);
      } else {
        setmessages([]);
      }
      setloadingMessages(false);
      setisEmojiPickerShown(false);
    };
    loadMessages();
    // eslint-disable-next-line
  }, [user, selected, load]);

  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  React.useEffect(() => {
    setisEmojiPickerShown(false);
  }, [message]);

  React.useEffect(() => {
    setmessage("");
  }, [selected]);

  React.useEffect(() => {
    if (preloadedMessages.length > 0) setmessages(preloadedMessages);
  }, [preloadedMessages]);

  let messageFound = tempMessage
    ? messages.find(
        (m) =>
          m.message === tempMessage.message && m?.from?._id === user?.info?._id
      )
    : true;
  let displayMessages =
    messageFound || !(selected._id === tempMessage?.to?._id)
      ? messages
      : [...messages, tempMessage];

      
  let img_url = selected?.image
  ? selected?.image
  : url + selected?.profile?.url || UserProfile;

  return (
    <div className="chat-panel border mt-4 py-2 pl-2 pr-0">
      <div className="flex items-center m-2 pr-2">
        <FaAngleLeft
          className="text-lg text-gray-500 cursor-pointer mr-2"
          onClick={goBack}
        ></FaAngleLeft>
        <img
          src={img_url}
          alt={selected.username}
          className="object-cover"
          style={{ width: "40px", height: "40px", borderRadius: "50%" }}
        ></img>
        <div className="flex flex-1 items-center">
          <span className="font-weight-bold ml-2 mr-1 mt-2">
            {selected.username}
          </span>
          {selected?.account_type === "VERIFIED" && (
            <div title="Account verified">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"
                  fill="rgba(249,2,2,1)"
                />
              </svg>
            </div>
          )}
        </div>
        <p className="flex items-center gap-2 text-sm text-gray-500 cursor-pointer pt-3">
          <span>English</span> <FaAngleDown></FaAngleDown>
        </p>
      </div>

      <div className="chat-buttons mx-2 mt-3 flex pr-2">
        <p className="font-weight-bold text-sm flex-1">
          Auto English Translation
        </p>
        <FaPhone className="text-lg mx-2 text-fire cursor-pointer"></FaPhone>
        <FaVideo className="text-lg mx-2 text-fire cursor-pointer"></FaVideo>
      </div>

      <div className="chat-list mt-3 pr-1">
        <MessagesComponent
          messages={displayMessages}
          chat={selected}
          loadingMessages={loadingMessages}
        ></MessagesComponent>
        <div className="flex shadow-xs message-input items-center gap-2 mx-3">
          <form
            onSubmit={sendmessage}
            className={
              dark
                ? "darkmode--search border flex py-1 px-2 items-center gap-1 flex-1"
                : "flex bg-gray-50 py-1 px-2 items-center gap-1 flex-1"
            }
            style={{ borderRadius: "10px" }}
          >
            <div
              className={`emoji-picker-container bg-white absolute bottom-20 left-8 shadow-lg w-1/2${
                isEmojiPickerShown ? "" : " hidden"
              }`}
            >
              <Picker
                onEmojiClick={onEmojiClick}
                skinTone={SKIN_TONE_MEDIUM_DARK}
              />
            </div>
            <FaSmile
              className="text-gray-500 cursor-pointer"
              onClick={toggleEmojiPicker}
            ></FaSmile>
            <input
              type="text"
              placeholder="Type a message"
              className={
                dark
                  ? "darkmode outline-none flex-1 p-3"
                  : "bg-gray-50 outline-none flex-1 p-3"
              }
              value={message}
              onChange={handlemessage}
              onFocus={() => setisEmojiPickerShown(false)}
              onKeyUp={inputkeyup}
            ></input>
            <FaPaperPlane
              onClick={sendmessage}
              className="text-gray-500 cursor-pointer"
            ></FaPaperPlane>
          </form>
          <FaFire
            onClick={() => {
              setmessage(`${message}🔥`);
            }}
            className="text-gray-500 text-base cursor-pointer"
          ></FaFire>
        </div>
      </div>
    </div>
  );
}
